import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { getSubscriptionTitle } from '../helpers';

import { Box, Text } from 'components/library';

import * as S from './styled';

import { IPriceRow } from '../types';

const PriceRow = ({ period, price, color, subscriptionType, withFreeMonth }: IPriceRow) => {
    const { t } = useTranslation();
    const paymentLabel = getSubscriptionTitle(period, false);

    return (
        <S.PriceRow>
            <Text type="medium-text" color={color}>
                <Trans
                    i18nKey="subscription.period"
                    values={{ count: paymentLabel?.count, context: paymentLabel?.context, subscriptionType }}
                />
                {withFreeMonth && <Box>{t('subscription.text.freeMonthPostfix')}</Box>}
            </Text>
            <Text type="medium-text" color={color}>
                {price}
            </Text>
        </S.PriceRow>
    );
};

export default PriceRow;
